// @ts-ignore
import { useMutation, UseMutationResult } from "react-query";

import { ApiRoutes } from "../../constants/ApiRoutes";
import { httpClient } from "../../api-legacy/BaseApi";

export function useSavePatientDetailsMutation(): UseMutationResult<unknown, Error, any> {
  return useMutation((data) => httpClient.put(ApiRoutes.SavePatientDetails, { data }));
}
